import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";
import FileNameWithIcon from "../../../../components/fileNameWithIcon";

function CvInformation({
  onEditClick = () => {},
  isShowEditIcon = false,
  cvData = {},
}) {
  const [t] = useTranslation();

  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);

  return (
    <div
      id="cvSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className="flex flex-col items-start gap-3 self-stretch">
        <div className="flex justify-between items-center self-stretch">
          <span className="text-[#1D1B22] text-center font-semibold text-[24px] leading-[36px] font-['General_Sans']">
            {t("CV")}
          </span>
          {isShowEditIcon && (
            <EditIcon
              className={`cursor-pointer ${
                isEditShowEditOnHover ? "visible" : "invisible"
              }`}
              onClick={onEditClick}
            />
          )}
        </div>
      </div>

      <div className="flex flex-wrap gap-[20px]">
        <LabelComponent
          title={`Last Updated ${cvData?.updatedAt}`}
          subTitle={
            <FileNameWithIcon
              fileName={cvData?.name}
              showHover={false}
              onDeleteHandler={() => console.log("to be wwwww")}
              onDownload={() => console.log("to be implemented")}
            />
          }
        />
      </div>
    </div>
  );
}

CvInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default CvInformation;
